import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Report';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import WarningIcon from '@material-ui/icons/Warning';
import blue from '@material-ui/core/colors/blue';
import amber from '@material-ui/core/colors/amber';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/green';


const variantIcon = {
  info: InfoIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  success: CheckCircleIcon
};

const styles = theme => ({
  info: {
    backgroundColor: blue[900],
  },
  warning: {
    backgroundColor: amber[700],
  },
  error: {
    backgroundColor: red[800],
  },
  success: {
    backgroundColor: green[600],
  },
  icon: {
    fontSize: 22,
  },
  iconVariant: {
    marginRight: theme.spacing.unit * 1.5,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 14
  },
  closeIconSize: {
    width: '32px',
    height: '32px'
  }
});

function SnackbarAlertContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby='snackbarAlert'
      message={
        <span id='snackbarAlert' className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton key='close' aria-label='Close' color='inherit' className={classes.closeIconSize} onClick={onClose}>
          <CloseIcon className={classes.icon} />
        </IconButton>
      ]}
      {...other}
    />
  );
}

SnackbarAlertContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['info', 'warning', 'error', 'success']).isRequired,
};

const SnackbarAlertWrapper = withStyles(styles)(SnackbarAlertContent);


class SnackbarAlert extends React.Component {

  handleCloseSnackbar = () => {
    this.props.handleCloseSnackbar();
  };


  render() {

    return (
      <div>

        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.props.openInfo}
          onClose={this.handleCloseSnackbar.bind(this)}
        >
          <SnackbarAlertWrapper
            onClose={this.handleCloseSnackbar.bind(this)}
            variant='info'
            message={this.props.alertMessage}
          />
        </Snackbar>

        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.props.openWarning}
          onClose={this.handleCloseSnackbar.bind(this)}
        >
          <SnackbarAlertWrapper
            onClose={this.handleCloseSnackbar.bind(this)}
            variant='warning'
            message={this.props.alertMessage}
          />
        </Snackbar>

        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={this.props.openError}
          onClose={this.handleCloseSnackbar.bind(this)}
        >
          <SnackbarAlertWrapper
            onClose={this.handleCloseSnackbar.bind(this)}
            variant='error'
            message={this.props.alertMessage}
          />
        </Snackbar>

        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          autoHideDuration={this.props.autoHideDuration}
          open={this.props.openSuccess}
          onClose={this.handleCloseSnackbar.bind(this)}
        >
          <SnackbarAlertWrapper
            onClose={this.handleCloseSnackbar.bind(this)}
            variant='success'
            message={this.props.alertMessage}
          />
        </Snackbar>

      </div>
    );
  }
}

export default SnackbarAlert;


// WEBPACK FOOTER //
// ./src/components/Utils/SnackbarAlert.js